import moment from 'moment';

export function formatComputedAt(iso: string): string {
    return `Updated ${moment(iso).format('MMM D, h:mm A')}`;
}
